import React, { useContext } from 'react'
import { Modal } from 'shared/components/modal'
import { Container, SmallTitle, Description, UploadButton, MoreInfo, Overlay, TitleGif, BottomGif } from './sc'
import UserContext from 'shared/contexts/user'
import useLocalStorage from 'react-use/lib/useLocalStorage'
import { googleAnalyticsEvent } from 'shared/util/analytics'

const ClipsUploadBanner = () => {
    const [hasSeenUploadMessage, setHasSeenUploadMessage] = useLocalStorage(`has-seen-upload-message`, false)
    const { user } = useContext(UserContext)

    if (hasSeenUploadMessage || (!user?.permissions?.upload_videos && !user?.isStaff)) return <></>

    const moreInfo = (e) => {
        e.preventDefault()
        setHasSeenUploadMessage(true)
        googleAnalyticsEvent({
            category: 'Upgraded Clips CTA',
            action: 'More Info Click',
            label: user.id,
        })

        window.location.href = 'https://support.giphy.com/hc/en-us/articles/4406655328026-GIPHY-Clips-FAQ'
    }

    const upload = () => {
        setHasSeenUploadMessage(true)
        googleAnalyticsEvent({
            category: 'Upgraded Clips CTA',
            action: 'Upload Click',
            label: user.id,
        })

        // cant use history.push cause i need the refresh
        window.location.href = 'http://giphy.com/upload'
    }

    const close = () => {
        setHasSeenUploadMessage(true)
    }

    return (
        <Modal>
            <Container>
                <SmallTitle>INTRODUCING</SmallTitle>
                <TitleGif src="https://media.giphy.com/media/H1NRYiAFWc0WhjSKa5/giphy.gif" />
                <Description>
                    Culture-defining quips, quotes, and reactions. Add your Clips to make them shareable wherever
                    conversations are happening.
                </Description>
                <UploadButton onClick={upload}>Upload A Clip!</UploadButton>
                <MoreInfo onClick={moreInfo}>More Info</MoreInfo>
                <BottomGif src="https://media.giphy.com/media/XezX2jNHHVo60Y8zWz/giphy.gif" />
            </Container>
            <Overlay onClick={close} />
        </Modal>
    )
}

export default ClipsUploadBanner
